<div style="width: 100%; height: 100%">

  <div id="delete-modal" *ngIf="modalTitle == 'Delete Client Information'" [formGroup]="deleteClientInfoForm">
    <div class="delete-modal-inner">
      <div class="delete-modal-content">
        <mat-label style = "font-size: 16px;">Confirm to delete this Client's Info?<br><br></mat-label>
        <input matInput type="string" formControlName="client_name" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
        <input matInput type="string" formControlName="client_uuid" hidden>
      </div>
      <div class="delete-modal-buttons">
        <button type="button" class="confirm"  (click)="deleteClientInfo()" >Confirm</button>
        <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
      </div>
    </div>
  </div>


  <div id="delete-modal" *ngIf="modalTitle == 'Delete Email'" [formGroup]="deleteEmailForm">
    <div class="delete-modal-inner">
      <div class="delete-modal-content">
        <mat-label style = "font-size: 16px;">Confirm to delete this Client's Email?<br><br></mat-label>
        <input matInput type="string" formControlName="client_name" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
        <input matInput type="string" formControlName="email_uuid" hidden>
      </div>
      <div class="delete-modal-buttons">
        <button type="button" class="confirm"  (click)="deleteEmail()" >Confirm</button>
        <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
      </div>
    </div>
  </div>

  <div id="create-modal" *ngIf="modalTitle == 'Create New Email'" [formGroup]="createEmailForm">
    <div class="create-modal-inner">
        <div class="create-modal-content">
        <mat-form-field style="width: 100%;">
            <mat-label>Client Name</mat-label>
            <input matInput type="string" formControlName="clientname" placeholder="Type in name of Client">
        </mat-form-field>
        <mat-form-field style="width: 100%;">
            <mat-label>Email Address</mat-label>
            <input matInput type="string" formControlName="email" placeholder="Type in the email address">
        </mat-form-field>
      </div>      
      <div class="create-modal-buttons">
        <button type="button" class="confirm"  (click)="createEmail()" >Create</button>
        <button type="button" class="cancel" (click)="closeModal()">Cancel</button>        
      </div>
    </div>
  </div>

  <div id="create-modal" *ngIf="modalTitle == 'Delete Pending Email'" [formGroup]="deletePendingEmailForm">
    <div class="delete-modal-inner">
      <div class="delete-modal-content">
        <mat-label style = "font-size: 16px;">Confirm to delete this Client's Email?<br><br></mat-label>
        <input matInput type="string" formControlName="client_name" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
        <input matInput type="string" formControlName="pces_outgoing_email_uuid" hidden>
      </div>
      <div class="delete-modal-buttons">
        <button type="button" class="confirm"  (click)="deletePendingEmail()" >Confirm</button>
        <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
      </div>
    </div>
  </div>

  <div id="create-modal" *ngIf="modalTitle == 'Delete Pending Transaction'" [formGroup]="deletePendingTransactionForm">
    <div class="delete-modal-inner">
      <div class="delete-modal-content">
        <mat-label style = "font-size: 16px;">Confirm to delete this Client's Transaction?<br><br></mat-label>
        <input matInput type="string" formControlName="client_name" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
        <input matInput type="string" formControlName="pces_transaction_uuid" hidden>
      </div>
      <div class="delete-modal-buttons">
        <button type="button" class="confirm"  (click)="deletePendingTransaction()" >Confirm</button>
        <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
      </div>
    </div>
  </div>

  <div id="create-modal"  *ngIf="modalTitle == 'Send Email'" [formGroup]="sendEmailForm">
    <div class="delete-modal-inner">
      <div class="delete-modal-content">
        <mat-label style = "font-size: 16px;">Confirm to Send Email?<br><br></mat-label>
        <input matInput type="string" formControlName="client_name" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%">
        <input matInput type="string" formControlName="pces_outgoing_email_uuid" hidden>
      </div>
      <div class="delete-modal-buttons">
        <button type="button" class="confirm"  (click)="sendPendingEmail()" >Confirm</button>
        <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
      </div>
    </div>
  </div>

  
  <div id="create-modal" *ngIf="modalTitle == 'Send ALL Email'" [formGroup]="sendALLEmailForm">
    <div class="delete-modal-inner">
      <div class="delete-modal-content">
        <mat-label style = "font-size: 16px;">Confirm to Send ALL Email?<br><br></mat-label>
      </div>
      <div class="delete-modal-buttons">
        <button type="button" class="confirm"  (click)="sendALLPendingEmail()" >Confirm</button>
        <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
      </div>
    </div>
  </div>
  
  <div  id="create-modal" *ngIf="modalTitle == 'Delete ALL Transaction'" [formGroup]="deleteAllTransactionForm">
    <div class="delete-modal-inner">
      <div class="delete-modal-content">
        <mat-label style = "font-size: 16px;">Confirm to Delete All Transaction?<br><br></mat-label>
      </div>
      <div class="delete-modal-buttons">
        <button type="button" class="confirm"  (click)="deleteAllPendingTransaction()" >Confirm</button>
        <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
      </div>
    </div>
  </div>
  
  <div  id="create-modal" *ngIf="modalTitle == 'Delete All Pending Email'" [formGroup]="deleteAllEmailForm">
    <div class="delete-modal-inner">
      <div class="delete-modal-content">
        <mat-label style = "font-size: 16px;">Confirm to Delete All Pending Emails?<br><br></mat-label>
      </div>
      <div class="delete-modal-buttons">
        <button type="button" class="confirm"  (click)="deleteAllPendingEmail()" >Confirm</button>
        <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
      </div>
    </div>
  </div>

  <!-- Upload Payment Report File -->
  <div *ngIf="modalTitle == 'Upload Payment Report File'" [formGroup]="uploadPaymentReportFileForm">
    <div class="upload-modal-inner ">
      <h1 style="flex-basis: 100%;">{{modalTitle}}</h1>
      <span style="flex-basis: 100%;">
          <mat-form-field style="width: 100%;">
              <mat-label>Starting No.</mat-label>
              <input type="number" matInput formControlName="start_no"  placeholder="Type in offset">
          </mat-form-field>
      </span>
      <span style="flex-basis: 100%;">
        <mat-form-field style="width: 100%;">
            <mat-label>Limit</mat-label>
            <input type="number" matInput formControlName="limit"  placeholder="Type in limit">
        </mat-form-field>
      </span>  
      <input #fileInput type="file" (change)="onFileSelected($event)" style="font-size: large" mat-raised-button color="primary">
      <span style="flex-basis: 100%; display: flex; justify-content: flex-end;">
          <button mat-button (click)="closeModal()" color="accent">Close</button>
          <button (click)="submitPaymentReportFile()" mat-button color="primary">Upload</button>
      </span>
    </div>    
  </div>
  <div class="spinner-overlay" *ngIf="showSpinner">
    <!-- Spinner and loading text -->
    <mat-spinner diameter="20"></mat-spinner>
    <p>Loading...</p>
  </div>
  
  <!-- Upload Transaction Report File -->
  <div *ngIf="modalTitle == 'Upload Transaction File'" [formGroup]="uploadTransactionFileForm">
    <div class="upload-modal-inner ">
      <h1 style="flex-basis: 100%;">{{modalTitle}}</h1>
      <input #fileInput type="file" (change)="onFileSelected($event)" style="font-size: large" mat-raised-button color="primary">
      <span style="flex-basis: 100%; display: flex; justify-content: flex-end;">
          <button mat-button (click)="closeModal()" color="accent">Close</button>
          <button (click)="submitTransactionFile()" mat-button color="primary">Upload</button>
      </span>
    </div>
  </div>
  <div class="spinner-overlay" *ngIf="showSpinner">
      <!-- Spinner and loading text -->
      <mat-spinner diameter="20"></mat-spinner>
      <p>Loading...</p>
  </div>

  <!-- Create a Canadian Transaction File -->
  <div id="create-modal"  *ngIf="modalTitle == 'Create CDN Transaction File'" [formGroup]="createCDNTransactionFileForm">
      <div class="create-modal-inner">
          <div class="create-modal-content">       
            <mat-form-field style="width: 100%;">
            <mat-label>Days to Wait Before Activating:</mat-label>
              <input matInput type="string" formControlName="days" placeholder="Type in days">
          </mat-form-field>
        </div>      
        <div class="create-modal-buttons">
          <button type="button" class="confirm"  (click)="submitCreateCDNTransactionFile()" >Create</button>
          <button type="button" class="cancel" (click)="closeModal()">Cancel</button>        
        </div>
      </div>
  </div>
  <div class="spinner-overlay" *ngIf="showSpinner">
      <!-- Spinner and loading text -->
      <mat-spinner diameter="20"></mat-spinner>
      <p>Loading...</p>
  </div> 

  <!-- Create a US Transaction File -->
  <div id="create-modal"  *ngIf="modalTitle == 'Create US Transaction File'" [formGroup]="createUSTransactionFileForm">
    <div class="create-modal-inner">
        <div class="create-modal-content">       
          <mat-form-field style="width: 100%;">
          <mat-label>Days to Wait Before Activating:</mat-label>
            <input matInput type="string" formControlName="days" placeholder="Type in days">
        </mat-form-field>
      </div>      
      <div class="create-modal-buttons">
        <button type="button" class="confirm"  (click)="submitCreateUSTransactionFile()" >Create</button>
        <button type="button" class="cancel" (click)="closeModal()">Cancel</button>        
      </div>
    </div>
  </div>
  <div class="spinner-overlay" *ngIf="showSpinner">
    <!-- Spinner and loading text -->
    <mat-spinner diameter="20"></mat-spinner>
    <p>Loading...</p>
  </div> 

  <!-- Create a US CDN Transaction File -->
  <div id="create-modal"  *ngIf="modalTitle == 'Create US/CDN Transaction File'" [formGroup]="createUS_CDNTransactionFileForm">
    <div class="create-modal-inner">
        <div class="create-modal-content">       
          <mat-form-field style="width: 100%;">
          <mat-label>Days to Wait Before Activating:</mat-label>
            <input matInput type="string" formControlName="days" placeholder="Type in days">
        </mat-form-field>
      </div>      
      <div class="create-modal-buttons">
        <button type="button" class="confirm"  (click)="submitCreateUS_CDNTransactionFile()" >Create</button>
        <button type="button" class="cancel" (click)="closeModal()">Cancel</button>        
      </div>
    </div>
  </div>
  <div class="spinner-overlay" *ngIf="showSpinner">
    <!-- Spinner and loading text -->
    <mat-spinner diameter="20"></mat-spinner>
    <p>Loading...</p>
  </div> 

</div>